import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';

export const tracker = createTracker({ events });

function getApp() {
  return window.location.pathname.split('/')[1];
}

export const trackInteraction = (interaction: string) => {
  tracker.track('toolAccessInteraction', {
    app: getApp(),
    interaction,
  });
};

export const trackRequestCreated = ({
  roleName,
  scope,
}: {
  roleName: string;
  scope: string;
}) =>
  tracker.track('toolAccessRequestCreated', {
    app: getApp(),
    role: roleName,
    value: scope,
  });
